/**
 * Modelo para las relaciones entre tiendas e integraciones
 * Maneja la configuración específica de cada integración por tienda
 */

export interface StoreIntegrationConfiguration {
  // Configuración común para integraciones de pago
  publicKey?: string;
  secretKey?: string;
  accessToken?: string;
  clientId?: string;
  clientSecret?: string;
  
  // URLs de configuración
  webhookUrl?: string;
  notificationUrl?: string;
  returnUrl?: string;
  cancelUrl?: string;
  
  // Configuración de ambiente
  environment?: 'production' | 'sandbox' | 'test';
  
  // Configuración específica por tipo de integración
  merchantId?: string;
  apiKey?: string;
  apiSecret?: string;
  
  // Configuraciones adicionales dinámicas
  [key: string]: any;
}

export interface StoreIntegration {
  id?: number;
  storeId: number;
  integrationId: number;
  isActive: boolean;
  configuration: StoreIntegrationConfiguration;
  notes?: string;
  createdAt?: string;
  updatedAt?: string;
  
  // Información expandida (para consultas con joins)
  integration?: {
    id: number;
    name: string;
    type: string;
    description?: string;
  };
  store?: {
    id: number;
    name: string;
  };
}

export interface CreateStoreIntegrationDto {
  storeId: number;
  integrationId: number;
  isActive: boolean;
  configuration: StoreIntegrationConfiguration;
  notes?: string;
}

export interface UpdateStoreIntegrationDto {
  isActive?: boolean;
  configuration?: StoreIntegrationConfiguration;
  notes?: string;
}

export interface StoreIntegrationResponse {
  success: boolean;
  data: StoreIntegration;
  message?: string;
}

export interface StoreIntegrationListResponse {
  success: boolean;
  data: StoreIntegration[];
  total?: number;
  page?: number;
  limit?: number;
  message?: string;
}

/**
 * Configuraciones por defecto para diferentes tipos de integraciones
 */
export const DEFAULT_INTEGRATION_CONFIGS: Record<string, Partial<StoreIntegrationConfiguration>> = {
  'mercadopago': {
    environment: 'sandbox',
    publicKey: '',
    accessToken: '',
    webhookUrl: '',
    notificationUrl: ''
  },
  'stripe': {
    environment: 'test',
    publicKey: '',
    secretKey: '',
    webhookUrl: ''
  },
  'paypal': {
    environment: 'sandbox',
    clientId: '',
    clientSecret: '',
    returnUrl: '',
    cancelUrl: ''
  },
  'visa': {
    environment: 'test',
    merchantId: '',
    apiKey: '',
    apiSecret: ''
  }
};